import InputFieldWithValidation, { IInputFieldWithValidationProps } from "components/InputFieldWithValidation";


export default function EmailInput(
  {
    readonlyEmail
  }: {
    readonlyEmail?: string
  }
) {
  const inputProps: IInputFieldWithValidationProps = {
    name: "email",
    label: <span className="rebrand:text-base rebrand:text-neutral-900">Email Address</span>,
    type: "email",
    placeholder: "Please enter your email address",
    required: true,
    typeMismatchErrorMessage: "Please enter a valid email address",
    className: "rebrand:h-12 rebrand:rounded rebrand:border-neutral-900 rebrand:text-base"
  };

  if (readonlyEmail) {
    inputProps.contentEditable = false;
    inputProps.readOnly = true;
    inputProps.value = readonlyEmail;
  }

  return <InputFieldWithValidation { ...inputProps } />;
};
